import React, {useState, useEffect, useContext} from 'react';
import CommandsContext from '../../../context/commandsContext';
import useKeyPress from '../../../hooks/useKeyPress';
import FullBodyContentView from '../../views/fullBodyContentView';

function License({onExit}) {
  const leftPress = useKeyPress('ArrowLeft');
  const {onUpdateCommands} = useContext(CommandsContext);

  useEffect(() => {
    if (!leftPress) return;
    onExit();
  }, [leftPress]);

  useEffect(() => {
    setTimeout(() => {
      onUpdateCommands({onLeft: onExit});
    });
  }, [onExit]);
  return (
    <FullBodyContentView
      title="Permanent License"
      fullCaption="Permanent License Key................... 
      None..............................0.0.............
      Expiration (days).........0...................
      Licensed Features...........................
      No Licensed Features.....................
      Weights & Measures.......................
      API Referral.....................................
      Concentration Measurement...........
      Batcher............................................
      SIL...................................................
      APM Single Liquid...........................
      APM NOC........................................
      APM Wet Gas..................................
      Historian Data..................................
      "
    />
  );
}

export default License;
